import { AuthController } from "../../auth/AuthController.js";
import { DashboardController } from "../../dashboard/DashboardController.js";
import { KnowledgeController } from "../../knowledge/KnowledgeController.js";
import { AdminController } from "../../admin/AdminController.js";
import { ChatController } from "../../chat/ChatController.js";
import { VistaService } from "../utils/VistaService.js";
import { AuthService } from "../services/AuthService.js";

export class Router {
  constructor() {
    this.routes = {
      "": () => (this.isAuthenticated ? DashboardController.render() : AuthController.renderLogin()),
      login: () => AuthController.renderLogin(),
      // Con un proveedor de ingreso externo, la contraseña la maneja ese proveedor
      "forgot-password": () => (AuthService.isExterno() ? AuthController.renderLogin() : AuthController.renderForgotPassword()),
      "set-password": (p) => (AuthService.isExterno() ? AuthController.renderLogin() : AuthController.renderSetPassword(p)),
      dashboard: () => this.requireAuth((p) => DashboardController.render(p)),
      knowledge: () => this.requireAuth((p) => KnowledgeController.render(p)),
      article: () => this.requireAuth((p) => KnowledgeController.renderArticle(p)),
      admin: () => this.requireAuth((p) => AdminController.render(p)),
      chat: () => this.requireAuth((p) => ChatController.render(p)),
    };
    this._primeraRuta = true;
  }

  // Se evalúa en cada navegación (no una vez al arrancar): el logout o un token
  // vencido cortan el acceso a las rutas protegidas sin recargar la página.
  get isAuthenticated() {
    return AuthService.hasValidSession();
  }

  init() {
    window.addEventListener("hashchange", () => this.handleRoute());
    this.handleRoute();
  }

  handleRoute() {
    let hash = window.location.hash.slice(1) || "";
    // Al abrir la app (o después del login, que recarga) el inicio respeta la vista
    // preferida; navegar a #dashboard durante la sesión no redirige.
    if (this._primeraRuta) {
      this._primeraRuta = false;
      const [inicial] = hash.split("?");
      if ((inicial === "" || inicial === "dashboard") && this.isAuthenticated && VistaService.inicio() === "chat") {
        hash = "chat";
        history.replaceState(null, "", "#chat");
      }
    }
    const [path, queryString] = hash.split("?");
    const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();
    const route = this.routes[path] || this.routes[""];
    this._updateFooter(path);
    // La vista chat ocupa toda la pantalla (sin scroll del body ni footer)
    document.body.classList.toggle("kb-chat-mode", path === "chat" && this.isAuthenticated);
    route(params);
  }

  _updateFooter(path) {
    const footer = document.getElementById("kb-footer");
    if (!footer) return;
    const publicOnly = ["login", "forgot-password", "set-password"];
    const hide = publicOnly.includes(path) || path === "chat" || (path === "" && !this.isAuthenticated);
    footer.classList.toggle("d-none", hide);
  }

  requireAuth(callback) {
    if (this.isAuthenticated) {
      return callback(new URLSearchParams(window.location.hash.split("?")[1] || ""));
    }
    window.location.hash = "login";
    return AuthController.renderLogin();
  }

  navigate(path) {
    window.location.hash = path;
  }
}
